import { StatelessComponent } from 'react'
import * as styles from 'styles/pages/Logout.css'
import CommonLayout from 'components/layouts/CommonLayout'
import CardLayout from 'components/layouts/CardLayout'
import Button from 'components/features/pfm/Button/Button'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import Anchor from 'components/atoms/navigation/Anchor'
import { SUPPORT_EMAIL } from 'constants/email'
import { EmailLink } from 'components/features/pfm/EmailLink/EmailLink'
import { SITE_URL } from 'tangle-shared'
import ShareButtonContainer from 'components/features/pfm/ShareButton/ShareButtonContainer'

const SITE_SHARE_TEXT = '@StatusMoneyUSA shows you how your finances compare to people like you and millions of others! Join for free at:'

const Logout: StatelessComponent = () => (
  <Anchor placement='logout'>
    <CommonLayout>
      <CardLayout title='Log Out Successful.'>
        <div className={ styles.contentWrapper }>
          <NavigationLink to='login'>
            <Button text='login' fullWidth />
          </NavigationLink>
          <div className={ styles.share }>
            <div className={ styles.shareText }>
              Invite everyone to compare their finances and find opportunities for&nbsp;free!
            </div>
            <ul className={ styles.shareButtons }>
              <li className={ styles.shareButtonWrapper }>
                <ShareButtonContainer method='facebook' url={ SITE_URL }>
                  Share
                </ShareButtonContainer>
              </li>
              <li className={ styles.shareButtonWrapper }>
                <ShareButtonContainer method='twitter' text={ SITE_SHARE_TEXT } url={ SITE_URL } />
              </li>
            </ul>
          </div>
        </div>
      </CardLayout>
      <div className={ styles.emailSection }>
        If you have suggestions,<br />
        please email us at: <EmailLink email={ SUPPORT_EMAIL } />
      </div>
    </CommonLayout>
  </Anchor>
)

export default Logout
